import { formatDate, formatDateTime, formatNumber } from "./base_func";
import { mapState } from "vuex";

export let BaseFormData = function() {
  return {
    props: {
      id: [Number, String],
      base_view_url: String,
      action: String,
      item_type: String
    },
    model: {
      prop: "id",
      event: "change"
    },
    data() {
      return {
        loading: true,
        // schema: {},
        baseRules: {},
        extraRules: {},
        excludeFieldsRules: [],
        validForm: false,
        isChanged: false,

        formData: {},

        formDefaultInitData: {},

        formSelectOptions: {}
      };
    },
    computed: {
      disabledSaveButton() {
        return !this.isChanged || !this.validForm;
      },

      ...mapState([
        "user_id",
        "user_full_name",
        "current_view",
        "current_view_parent",
        "currency",
        "permissions",
        "role",
        "role_display",
        "use_fiscal",
        "company_name",
        "cashes"
      ])

      // rules() {
      //   return Object.assign(this.baseRules, this.extraRules);
      // }
    },
    asyncComputed: {
      schema: {
        get() {
          return this.$http
              .options(this.base_view_url)
              .then(response => {
            let schema = response.data.actions.POST;

            // Записываем правила валидации в this.baseRules
            for (let field in schema) {
              if (this.excludeFieldsRules.indexOf(field) === -1) {
                if (schema[field].required) {
                  if (schema[field].type === "field") {
                    this.baseRules[field] = [
                      {
                        required: true,
                        // type: "number",
                        // message: this.schema[field].help_text,
                        message: "Выберите корректное значение поля",
                        trigger: "change"
                      }
                    ];
                  } else if (schema[field].type === "string") {
                    this.baseRules[field] = [
                      {
                        required: true,
                        // message: this.schema[field].help_text,
                        message: "Введите корректное значение поля",
                        trigger: "blur"
                      }
                    ];
                  } else if (schema[field].type === "integer") {
                    this.baseRules[field] = [
                      {
                        required: true,
                        type: "number",
                        // message: this.schema[field].help_text,
                        message: "Введите корректное значение поля",
                        trigger: "blur"
                      }
                    ];
                  } else if (schema[field].type === "choice") {
                    this.baseRules[field] = [
                      {
                        required: true,
                        // message: this.schema[field].help_text,
                        message: "Выберите корректное значение поля",
                        trigger: "blur"
                      }
                    ];
                  }
                }
              }
              this.$watch("formData." + field, function(newValue, oldValue) {
                this.validateForm();
                this.isChanged = true;
              });
            }

            // this.getRules();
            return schema;
          });
        }
        // default() {
        //   let fields = {};
        //   for (let field in this.formData) {
        //     fields[field] = "";
        //   }
        //   return fields;
        // }
      },
      rules: {
        get() {
          //this.getRules();
          return Object.assign(this.baseRules, this.extraRules);
        },
        watch: ["schema"]
      }
    },
    methods: {
      initialRoute(route) {
        if (route.name === this.item_type) {
          this.showList();
        } else if (route.name === this.item_type + "_detail") {
          this.showDetail(this.id);
        }
      },
      // fetchSchema() {
      //   this.$http
      //     .options(this.base_view_url)
      //     .then(response => {
      //       this.schema = response.data.actions.POST;
      //       this.getRules();
      //     })
      //     .catch(error => {
      //       this.$Message.error("Ошибка получения схемы");
      //     });
      // },

      fetchInitialData() {
        this.$http
          .get(`${this.base_view_url}${this.id}/`)
          .then(response => {
            this.formData = response.data;

            for (let field in this.formData) {
              this.formData[field] = response.data[field];
            }

            // this.fetchSchema();
          })
          .finally(() => {
            this.loading = false;
          });
      },

      validateForm() {
        this.$refs.formData.validate(valid => {
          this.validForm = valid;
        });
      },

      saveAction() {
        this.validateForm();
        if (this.validForm) {
          this.save();
        } else {
          this.$Message.error("Некорректно заполнены поля!");
        }
      },

      save() {
        let http_method = "put";
        let url = this.base_view_url + this.id + "/?format=json";
        
        if (this.action === "create") {
          http_method = "post";
          url = this.base_view_url + "?format=json";
        }
        this.loading = true;
        this.$http[http_method](url, this.formData)
        
          .then(response => {
            this.$Message.success("Успешно сохранено");
            if (this.item_type !== "debtor") {
            this.$router.push({
              name: this.item_type + "_detail",
              params: { id: response.data.id }
            });
              if (this.action === "create") {
                this.$emit("change", response.data.id);
              }
            }
            else {
              this.$router.push({
                name: this.item_type + "_detail",
                params: { id: this.formData.counterpart.id }
              });
            }
            this.$emit("reload_table");
            // this.showDetail(response.data.id);
          })
          .finally(() => {
            this.loading = false;
          });
      },

      // Установка правил валидации полей согласно схеме
      // getRules() {
      //   for (let field in this.schema) {
      //     if (this.excludeFieldsRules.indexOf(field) === -1) {
      //       if (this.schema[field].required) {
      //         if (this.schema[field].type === "field") {
      //           this.baseRules[field] = [
      //             {
      //               required: true,
      //               type: "number",
      //               // message: this.schema[field].help_text,
      //               message: "Выберите корректное значение поля",
      //               trigger: "change"
      //             }
      //           ];
      //         } else if (this.schema[field].type === "string") {
      //           this.baseRules[field] = [
      //             {
      //               required: true,
      //               // message: this.schema[field].help_text,
      //               message: "Введите корректное значение поля",
      //               trigger: "blur"
      //             }
      //           ];
      //         } else if (this.schema[field].type === "integer") {
      //           this.baseRules[field] = [
      //             {
      //               required: true,
      //               type: "number",
      //               // message: this.schema[field].help_text,
      //               message: "Введите корректное значение поля",
      //               trigger: "blur"
      //             }
      //           ];
      //         } else if (this.schema[field].type === "choice") {
      //           this.baseRules[field] = [
      //             {
      //               required: true,
      //               // message: this.schema[field].help_text,
      //               message: "Выберите корректное значение поля",
      //               trigger: "blur"
      //             }
      //           ];
      //         }
      //       }
      //     }
      //     this.$watch("formData." + field, function(newValue, oldValue) {
      //       this.validateForm();
      //       this.isChanged = true;
      //     });
      //   }
      // },

      // showValidationErrorStr(data) {
      //   if ("code" in data && "message" in data) {
      //     this.$Message.error(data.message);
      //   } else {
      //     let count = 0;
      //     let error_str = "";
      //     for (let field in data) {
      //       if (this.isObject(data[field])) {
      //         for (let field2 in data[field]) {
      //           // console.log(data[field]);
      //           if (count === 0)
      //             error_str =
      //               this.schema[field2].label +
      //               ": " +
      //               data[field][field2].join(". ");
      //           else
      //             error_str +=
      //               "<br>" +
      //               this.schema[field2].label +
      //               ": " +
      //               data[field][field2].join(". ");
      //         }
      //       } else {
      //         if (count === 0)
      //           error_str =
      //             this.schema[field].label + ": " + data[field].join(". ");
      //         else
      //           error_str +=
      //             "<br>" +
      //             this.schema[field].label +
      //             ": " +
      //             data[field].join(". ");
      //       }
      //
      //       count++;
      //     }
      //     this.$Message.error({ content: error_str, duration: 5 });
      //   }
      // },

      // User actions
      cancelAction() {
        this.$emit("click_cancel");
      },

      isObject(value) {
        return (
          value && typeof value === "object" && value.constructor === Object
        );
      },

      // Роутинг
      showList() {
        this.cancelAction();
      },
      showDetail(id) {
        this.$emit("show_detail", id);
      },

      // Форматирование
      formatNumber(number) {
        return formatNumber(number);
      },
      formatDate(date) {
        return formatDate(date);
      },
      formatDateTime(datetime) {
        return formatDateTime(datetime);
      }
    },
    watch: {
      action: function(to, from) {
        if (to === "create") {
          this.formData = this.formDefaultInitData;
        }
      },

      $route: function(to, from) {
        this.initialRoute(to);
      }
    },
    created() {
      if (this.action === "create") {
        //this.fetchSchema();
        this.formData = this.formDefaultInitData;
        this.loading = false;
      } else {
        //this.fetchSchema();
        this.fetchInitialData();
      }
    }
  };
};



// WEBPACK FOOTER //
// ./src/base/base_form_v2.js